import type { TerminalConnectionState } from './terminals-api.model';

export const TERMINAL_CONNECTION_THRESHOLDS = { warningAfterSeconds: 120, offlineAfterSeconds: 300 } as const;

export function connectionStateOf(lastSeenAt: Date | null, now: Date): TerminalConnectionState {
  if (!lastSeenAt) return 'never';
  const elapsedSeconds = (now.getTime() - lastSeenAt.getTime()) / 1000;
  if (elapsedSeconds >= TERMINAL_CONNECTION_THRESHOLDS.offlineAfterSeconds) return 'offline';
  if (elapsedSeconds >= TERMINAL_CONNECTION_THRESHOLDS.warningAfterSeconds) return 'warning';
  return 'online';
}
